import * as React from "react";
import { styled } from "utils";
import { FormGroup, Input, Label, IconButton, Text, Button } from "../atoms";
import { Card, CardTitle } from "../molecules";
import { IconCross, IconSearch } from "../icons";

const StyledForm = styled("form", {
  "@bp2": { display: "grid", gridTemplateColumns: "2fr 1fr", gap: "$3" },
});

type Props = React.ComponentProps<typeof Card> & {
  initialValue?: string;
  onSearch: (value: string) => void;
};

const SearchCard: React.FC<Props> = ({
  initialValue = "",
  onSearch,
  ...cardProps
}) => {
  const [value, setValue] = React.useState(initialValue);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    onSearch(value);
  };

  const showCross = value.length > 0;
  return (
    <Card as="div" {...cardProps}>
      <Label
        htmlFor="search"
        css={{ fontSize: "$5", fontWeight: "$extrabold" }}
      >
        <CardTitle
          as="span"
          css={{
            display: "block",
            lineHeight: 1,
            marginBottom: "$3",
            fontSize: "$5",
            fontWeight: "$bold",
          }}
        >
          Buscar propiedad
        </CardTitle>
      </Label>
      <StyledForm onSubmit={handleSearch}>
        <FormGroup css={{ position: "relative" }}>
          <Input
            id="search"
            value={value}
            onChange={(event) => setValue(event.target.value)}
            placeholder="Buscar por ubicación"
            css={{
              paddingLeft: "$3",
              paddingRight: "$6",
              marginBottom: "$3",
              "@bp2": { marginBottom: 0 },
            }}
          />
          <Text
            css={{
              position: "absolute",
              right: showCross ? "$2" : "$3",
              top: "$3",
            }}
          >
            {showCross ? (
              <IconButton
                type="button"
                onClick={() => {
                  setValue("");
                  onSearch("");
                }}
              >
                <IconCross width={24} height={24} />
              </IconButton>
            ) : (
              <IconSearch />
            )}
          </Text>
        </FormGroup>
        <Button type="submit" css={{ fontSize: "$4" }}>
          Buscar
        </Button>
      </StyledForm>
    </Card>
  );
};

export { SearchCard };
